import { Modal } from 'react-bootstrap';
import type { FunctionComponent } from 'react';

import Button, { ButtonGroup, LoaderButton } from '../../generic/Button';
import { ErrorAlert } from '../../generic/ErrorAlert';
import type { AsyncStatus } from '../../../types';

import styles from './SettingsPropagateModal.module.less';

type Props = {
  //  TODO: narrow this type later...
  settingsCategory: string;
  isOpen: boolean;
  onHide: () => void;
  errors: string[] | null;
  onSave: () => void;
  isSaveButtonDisabled: boolean;
  isSaveButtonLoading: boolean;
  //  Option to configure the description, but falls back to something reasonable.
  description?: string;
};

/**
 * SettingsPropagateModal is a generic wrapper for all propagate settings modals.
 */
const SettingsPropagateModal: FunctionComponent<Props> = ({
  children,
  isOpen,
  onHide,
  errors,
  settingsCategory,
  onSave,
  isSaveButtonDisabled,
  isSaveButtonLoading,
  description,
}) => {
  return (
    <Modal
      show={isOpen}
      onHide={onHide}
      className={styles.propagateModal}
    >
      <Modal.Header
        className={styles.modalHeader}
        closeButton
      >
        <h2 className={styles.heading}>
          Propagate {settingsCategory} settings
        </h2>
        <p className={styles.description}>
          {description || 'Which changes do you want to propagate to all projects?'}
        </p>
      </Modal.Header>
      <Modal.Body className={styles.modalBody}>
        <div className={styles.formGroup}>
          {children}
        </div>
        <div className={styles.warning}>
          <span className="bold">
            Warning!
          </span>
          {' '}
          This will override the settings for all projects. This can not be undone.
        </div>
        {(errors?.length ?? 0) > 0 && (
          <div className="margin-top-md">
            <ErrorAlert status={{ errors } as AsyncStatus} />
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <ButtonGroup>
          <Button
            type="secondary"
            size="medium"
            onClick={onHide}
          >
            Cancel
          </Button>
          <LoaderButton
            type="primary"
            size="medium"
            onClick={onSave}
            isDisabled={isSaveButtonDisabled}
            isLoading={isSaveButtonLoading}
          >
            Propagate settings
          </LoaderButton>
        </ButtonGroup>
      </Modal.Footer>
    </Modal>
  );
};

export default SettingsPropagateModal;
